module.exports = __webpack_public_path__ + "assets/static/svg/payment-error.53195c727faa7ed74b4b5a8f42f2b8f9.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/serviceReceipt/images/payment-error.svg
 ** module id = 530
 ** module chunks = 1
 **/